
import React, { Component } from 'react';
import { PlusOutlined, RightOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import './deviceManagePage.less';
import PubSub from 'pubsub-js'
import { Device_Map_Click, DEVICE_ota_group, DEVICE_show_layout,DEVICE_show_ota, DEVICE_type_item, Group_Map_Click } from "../../../const/infoConst";
import arrow_right from "../../../imgs/btn/arrow_right.png";
import arrow_down from "../../../imgs/btn/arrow_down.png";
import build from "../../../imgs/item/build.png";
import area from "../../../imgs/item/area.png";
import group from "../../../imgs/item/group.png";
import sensor from "../../../imgs/item/sensor.png";
import setting from "../../../imgs/item/setting.png";
import montion from "../../../imgs/item/montion.png";
import eye_show from "../../../imgs/btn/eye_show.png";
import wifi_4 from "../../../imgs/mesh/wifi_4.png";
import deviceType from "../../../imgs/item/deviceType.png";
import map_add from "../../../imgs/btn/map_add.png";
import map_del from "../../../imgs/btn/map_del.png";
import { getGroupNormalImgWithName, getGroupSelectImgWithName } from '../../../utils/fileUtils';
import { getAllGroupsAndDevices, judgeAddMapDevice, judgeAddMapGroup } from '../../../utils/meshUtils';
import { meshLog, SPSet, SPGet } from '../../../utils/spUtils';
import {IsDevicePir,IsEmergencyDevice} from '../../../utils/pidUtils'
import { sendOpcode_identify } from '../../../utils/opcodeUtils';
import { judgeDiffItemData } from '../../../utils/deviceUtils';


let itemType=0; //Device type 0~3
export default class DeviceManagePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type_arr:[{ id: 0, set: 1, name: 'Sensor' },
                   { id: 1, set: 0, name: 'Emergency Driver' },
                   { id: 2, set: 0, name: 'Emergency Lighting' },
                   { id: 3, set: 0, name: 'Controller' }],

            manage_arr:[{ id: 0, set: 1, name: 'Device Layout' },
                   { id: 1, set: 0, name: 'Device OTA' }],


            selectLayout:true, 

            //Device OTA----------
            groups:[],
            //Device Layout--------
            groupList: [], //布点图group集合
            group_selectId: 0,

            deviceList: [],
        };
    }

    componentDidMount() {
        const groupList = JSON.parse(SPGet("groupList"))
        this.setState({ 
            groups: getAllGroupsAndDevices(),
            groupList: groupList, 
        });
    }

    //Device Type选择
    typeSelectClick(id){
        let arr=this.state.type_arr;
        for(let i = 0; i < arr.length; i++){
            if(arr[i].id==id){
                arr[i].set=1;
            }else{
                arr[i].set=0;
            }
        }
        this.setState({ 
            type_arr: arr, 
        });
        itemType=id;
        PubSub.publish(DEVICE_type_item, id+""); //选择类别

        //组-分类数据
        let old=this.state.group_selectId;
        if(old>0){
            this.setState({ 
                deviceList: this.getDeviceListWithGroupIs(old),
            });
            PubSub.publish(Group_Map_Click, {'groupID':old})
        }
    }

    //Device Manage选择
    manageSelectClick(id){
        let arr=this.state.manage_arr;
        for(let i = 0; i < arr.length; i++){
            if(arr[i].id==id){
                arr[i].set=1;
            }else{
                arr[i].set=0;
            }
        }
        this.setState({ 
            manage_arr: arr, 
            selectLayout: id==0?true:false,
        });
                
        //界面更新
        if(id==0){
            this.props.onDataToParent(DEVICE_show_layout);
        }else if(id==1){    
            this.props.onDataToParent(DEVICE_show_ota);
        }
    }

    //------------------------------------------------Device OTA-----------------------------------------------------------
    //多选框--组
    handleCheckboxChange= (id) => {
        let arr=this.state.groups;
        for (let i = 0; i < arr.length; i++) {
            if(arr[i].id==id){
                arr[i].checked=!arr[i].checked;
            }
        }
        meshLog('wjk 多选框', id);
        this.setState({ groups: arr });
        PubSub.publish(DEVICE_ota_group, arr); //选择类别
    };

    //------------------------------------------------Device Layout-----------------------------------------------------------
    //伸展组--布点图
    groupArrowClick = (groupID) => {
        let old=this.state.group_selectId;
        if(old==0 || old!=groupID){
            this.setState({ 
                group_selectId: groupID, 
                deviceList: this.getDeviceListWithGroupIs(groupID),
            });
        }else{
            this.setState({ 
                group_selectId: 0, 
                deviceList: [],
            });
        }
        PubSub.publish(Group_Map_Click, {'groupID':groupID})
    };

    //根据组id获取设备
    getDeviceListWithGroupIs(groupID) {
        let arr=[];
        let count=0;
        let arrD = JSON.parse(SPGet("nodes"))
        for (let j = 0; j < arrD.length; j++) {
            if (arrD[j].groupID == groupID) {
                if(judgeDiffItemData(arrD[j].pid, itemType)){
                    arr[count] = arrD[j];
                    count++;
                }
            }
        }
        return arr;
    }


    //单灯
    selectHightLight = (device) => {
        PubSub.publish(Device_Map_Click, device.macAddress)//刷新Device的数据
    }
    //灯identify
    showHightLight = (device) => {
        sendOpcode_identify(device);
        PubSub.publish(Device_Map_Click, device.macAddress)//刷新Device的数据
    }


    //布点图相关-group
    designGroupClick=(group)=>{
        meshLog('designGroupClick',group.groupID);
        let arr=judgeAddMapGroup(group.groupID,group.mapModel.width);
        this.setState({ 
            group_selectId: group.groupID,
            groupList: arr ,
            deviceList: this.getDeviceListWithGroupIs(group.groupID),
        });

        let mId=group.groupID;
        if(group.mapModel.width>0){ //删除
            mId=-1;
        }
        PubSub.publish(Group_Map_Click, {'groupID':mId})//刷新组的数据
    }

    //布点图相关-device
    designDeviceClick = (device) => {
        meshLog('designDeviceClick', device.macAddress);
        let arr = judgeAddMapDevice(device.groupID, device.macAddress, device.mapModel.width);
        this.setState({
            deviceList: arr
        });

        PubSub.publish(Device_Map_Click, device.macAddress)//刷新Device的数据
    }


    render() {
        const {type_arr,manage_arr,selectLayout,deviceList,groupList,group_selectId} = this.state;
        return (
            <div className="device-management-container">
                {/*  Management 标题行 */}
                <div className="header-row">
                    <span>Device Mangagement</span>
                    {/* <InfoCircleOutlined className="help" /> */}
                </div>

                {/* Device Type */}
                <div className='item_type'>
                    <div className="item_header">
                        <div className="item_title">
                            <img className='icon' src={deviceType} />
                            <span>Device Type</span>
                        </div>
                    </div>
                    <div className="type_list_bg">
                        {type_arr.map((item) => (
                            <div key={item.id} className="type_item" onClick={() => { this.typeSelectClick(item.id) }}>
                              <span style={{ backgroundColor: item.set==1 ? "#f3f3f3" : "#ffffff" }}>{item.name}</span>
                            </div>
                        ))}      
                    </div>
           
                </div>

                {/* Device Manage */}
                <div className='item_manager'>
                    <div className="item_header">
                        <div className="item_title">
                            <img className='icon' src={setting} />
                            <span>Device Manage</span>
                        </div>
                    </div>

                    <div className="manager_list_bg">
                        {manage_arr.map((item) => (
                            <div key={item.id} className="type_item" onClick={() => { this.manageSelectClick(item.id) }}>
                                <span style={{ backgroundColor: item.set==1 ? "#f3f3f3" : "#ffffff" }}>{item.name}</span>
                            </div>
                        ))}      
                    </div>
                </div>


                {/* 布点图group */}
                <div className='item_list'>
                    <div className="item_header">
                        <div className="item_title">
                            <img className='icon' src={group} />
                            <span>Group</span>
                        </div>
                        {/* <img className='arrow' src={arrow_right} /> */}
                    </div>
                    {/* ------------------------------------------------Device OTA----------------------------------------------------------- */}
                    {/* group列表 */}
                    <div className="manage_group_ota"  style={{display: selectLayout ?"none":"flex"}}>
                        {this.state.groups.map((group) => (
                            <div key={group.id} className="group_item">
                                <img className="group-icon" src={getGroupNormalImgWithName(group.name)} />
                                <span>{group.name}</span>
                                <input className="radioSet" type='checkbox' name='group' value='' checked={group.checked} onChange={() => this.handleCheckboxChange(group.id)}/>   
                            </div>
                        ))}
                    </div>   
                    {/* ------------------------------------------------Device Layout----------------------------------------------------------- */}
                    <div className="manage_group_layout" style={{display: selectLayout ?"flex":"none"}}>
                        {groupList.map((group) => (
                            <div key={group.groupID} className="group_item">
                                <div className='group_title'>
                                    <div className='item_left' onClick={() => { this.groupArrowClick(group.groupID) }} >
                                        <img className='item_icon' src={group.groupID==group_selectId ? getGroupSelectImgWithName(group.groupImgName) : getGroupNormalImgWithName(group.groupImgName)} />
                                        <span style={{ color: group.groupID==group_selectId ? "#0B47BE" : "#595757" }}>{group.name}</span>
                                    </div>
                                    <div className='item_right'>
                                        <img className='mapBtn' src={group.mapModel.width>0?map_del:map_add} onClick={()=>this.designGroupClick(group)} />
                                        <img className='arrow' src={group.groupID==group_selectId ? arrow_down : arrow_right} onClick={() => { this.groupArrowClick(group.groupID) }}/>
                                    </div>
                                </div>
                                <div className='devices' style={{ display: group.groupID==group_selectId ? "flex" : "none" }}>
                                    {deviceList.map((device) => (
                                        <div key={device.macAddress} className="device_item">
                                            <div className='device_left'  onClick={() => { this.selectHightLight(device) }}>
                                                <img className='device_icon' src={montion} />
                                                <span>{device.name}</span>
                                            </div>
                                            <div className='device_right'>
                                                <img className='device_eye' onClick={() => { this.showHightLight(device) }} src={eye_show} />
                                                {/* <img className='device_sign' src={wifi_4} /> */}
                                                <img className='map_inner' src={device.mapModel.width > 0 ? map_del : map_add} onClick={() => this.designDeviceClick(device)} />
                                            </div>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        ))}
                    </div>
                </div>



            </div>
        );
    }
}
